import { Link, useMatchRoute } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import { CirclePlus } from "@/components/animate-ui/icons/circle-plus";
import { AnimateIcon } from "@/components/animate-ui/icons/icon";

import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar";

/**
 * Icon component type that supports optional animateOnHover prop
 */
type IconComponent = LucideIcon | React.ComponentType<{ animateOnHover?: boolean }>;

export function NavMain({
	items,
}: {
	items: {
		title: string;
		url: string;
		icon?: IconComponent;
	}[];
}) {
	const matchRoute = useMatchRoute();

	return (
		<SidebarGroup>
			<SidebarGroupContent className="flex flex-col gap-2">
				<SidebarMenu>
					<SidebarMenuItem className="flex items-center gap-2">
						<SidebarMenuButton
							tooltip="Quick Create"
							className="bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground active:bg-primary/90 active:text-primary-foreground data-[active=true]:bg-primary data-[active=true]:text-primary-foreground min-w-8 duration-200 ease-linear"
							isActive={!!matchRoute({ to: "/" })}
							asChild
						>
							<AnimateIcon animateOnHover asChild>
								<Link to="/">
									<CirclePlus />
									<span>Quick Create</span>
								</Link>
							</AnimateIcon>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
				<SidebarMenu>
					{items.map((item) => {
						const isActive = !!matchRoute({ to: item.url });
						return (
							<SidebarMenuItem key={item.title}>
								<SidebarMenuButton tooltip={item.title} isActive={isActive} asChild>
									<AnimateIcon animateOnHover asChild>
										<Link to={item.url}>
											{item.icon && <item.icon />}
											<span>{item.title}</span>
										</Link>
									</AnimateIcon>
								</SidebarMenuButton>
							</SidebarMenuItem>
						);
					})}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
